'use client';

import { createContext, useContext, useLayoutEffect } from 'react';

import { useHeaderVariant } from '@/shared/contexts/HeaderVariantContext';
import { useLNBOverlayReset } from '@/shared/hooks/useLNBOverlayReset';

const LNBDefaultOpenContext = createContext(false);

function useLNBDefaultOpenReset() {
  const { setDefaultLNBOpen } = useHeaderVariant();
  useLayoutEffect(() => {
    setDefaultLNBOpen(true);
    return () => setDefaultLNBOpen(null);
  }, [setDefaultLNBOpen]);
}

export function LNBDefaultOpenProvider({ children }: { children: React.ReactNode }) {
  useLNBOverlayReset();
  useLNBDefaultOpenReset();

  return (
    <LNBDefaultOpenContext.Provider value={true}>
      {children}
    </LNBDefaultOpenContext.Provider>
  );
}

export function useLNBDefaultOpen() {
  return useContext(LNBDefaultOpenContext);
}
